export default `
    # if (data.label || data.hcLabel) {#
        #
            if (data.label && z.ll(data.label, true) && z.ll(data.label).length > 15 && !data.toolTip) {
                data.toolTip = z.ll(data.label);
            }
        #
        <div id= "#= data.id#_cid"class="#=!data.preventDefault ? "pane-field" : ""# #= data.bsc # #= data.containerClasses #"
            # if (data.containerBind) { #data-bind="#=data.containerBind#" # } #
            # if (data.containerWidth)  { # style="width: #=data.containerWidth #px;" # } # class="# if (data.readonly) { # read-only # } #" 
        >
            <div class="row">
                <span class="#=!data.preventDefault ? "pane-field-label" : ""# #=data.labelClasses# #=data.labelBsc #">
                    #
                        if (data.infoTooltip || data.infoTooltipContent) {
                            #
                                <span class="#=!data.preventDefault ? "pane-field-text" : ""#">
                                    <span id="#= data.id #_info" class="pane-field-info"></span>
                                    <span
                                         class="bind-label" # if (data.labelWidth)  { # style="width: #=data.labelWidth #px;" # } # 
                                        # if (data.label) { #
                                             data-bind="#= data.label || "" #" 
                                             data-label-for-id="#= data.id #"
                                            # if (data.toolTip) { # 
                                                 title="#= data.toolTip #" # 
                                            } 
                                        }#
                                    >
                                    #=data.hcLabel || ""#
                                    </span>
                                </span>
                            #
                        } else {
                            #
                                <span
                                     class="#=!data.preventDefault ? "pane-field-text" : ""# 
                                     bind-label" 
                                    # if (data.labelWidth)  { # style="width: #=data.labelWidth #px;" # } # 
                                    # if (data.label) { #
                                         data-bind="#= data.label || "" #" 
                                         data-label-for-id="#= data.id #" 
                                        # if (data.toolTip) { # 
                                             title="#= data.toolTip #" # 
                                        } 
                                    }#
                                >
                                #=data.hcLabel || ""#
                                </span>
                            #
                        }
                    #
                </span>
                <span class="#= data.inputBsc # #if (data.clearable) { #clearable-input-container# }#">
                    <input data-lpignore="true" class="# if (data.readonly) { # read-only # } # #=!data.preventDefault ? "pane-field-input" : ""# bind-value #= data.classes || "" # #= data.iconInput ##if (data.clearable) { # clearable-input # }#" type="#=data.inputType || "text"#" id="#= data.id #" #if (data.placeholder) { # placeholder="#=data.placeholder#" # } #
                        # if (data.valueWidth)  { # style="width: #=data.valueWidth #px;" # } #
                        # if (data.required) { # required # } # # if (data.pattern) { # pattern="#= data.pattern #" # } #
                        # if (data.min) { # min="#= data.min #" # } # # if (data.max) { # max="#= data.max #" # } #
                        # if (data.step) { # step="#= data.step #" # } #
                        # if (data.maxLength) { # max-length="#= data.maxLength #" # } #
                        # if (data.bindValue) { # data-bind="#= data.bindValue #" # } #
                        # if (data.nan) { # nan="#= data.nan #" # } #
                        # if (data.minRange) { # min-range="#= data.minRange #" # } #
                        # if (data.disabled) { # disabled="#= data.disabled #" # } #
                        # if (data.readonly) { # readonly="#= data.readonly #" # } #
                        # if (data.name || data.entityType) { # name="#= data.name || data.entityType #" # } #
                        # if (data.valueUpdate) { # data-value-update="#= data.valueUpdate #" # } #
                        autocomplete="no!"
                    />
                    # if (data.bindNumberValue) { # <span class="pane-field-number bind-value  #= data.classes || "" # # if (data.disabled) { # disabled # } #"  data-bind="#= data.bindNumberValue #"></span> # } #
                    # if (data.bindTextAbove) { # <span class="pane-field-number bind-value  #= data.classes || "" # # if (data.disabled) { # disabled # } # "  data-bind="#= data.bindTextAbove #"></span> # } #
                    # if (data.required) { #
                        <span class="required">
                        </span>
                    # } #
                    # if (data.cf && !data.hideSS) { #
                        <span class="cf" title="#= z.ll("CustomFieldLabelTitle", true) #">
                            C
                        </span>
                    # } #
                    # if (data.clearable) { #
                        <div class="clear-input" title="#=z.ll("ClearField", true)#">
                        </div>
                    # } #
                    # if (data.iconType) { # 
                        <a id="#= data.iconId #" class="js-icon-type #= data.iconType # #= data.iconClasses # # if (data.disabled) { # disabled # } #">
                        # if (data.iconType == 'tech' || data.iconType == 'small-tech') { #
                            <i class="fas tech-badge"></i>
                        # } #
                        </a>
                    # } #
                    # if (data.useLink && data.linkedTo && data.linkedToBind) { # 
                        <label class="linked-wrapper">
                            <input id="#= data.id#_linked" type="checkbox" # if (data.disabled) { # disabled # } # class="linked-input bind-value" data-bind="checked: #= data.linkedToBind #" />
                            <span class="linked-container #= data.linkedClasses || "" # # if (data.disabled) { # disabled # } #" tooltip="When linked">
                                <span class="icon-link k-icon">
                                </span>
                            </span>
                        </label>
                    # } #
                </span>
            </div>
        </div>
    # } else { #
        # if (data.labelAbove || data.hcLabelAbove) { #
            <div id="#= data.id#_cid" class="woop-field  #= data.containerClasses #" # if (data.containerWidth) { # style="width: #= data.containerWidth #px;"# } #>
            <span>
                <span class="bind-label pad-r-5 dib"
                    # if (data.labelWidth) { # style="width: #= data.labelWidth #px;"# } #
                    # if (data.labelAbove) { # data-bind="#= data.labelAbove #" # } #
                    data-label-for-id="#= data.id #"
                >
                #=data.hcLabelAbove || ""#
                </span>
            </span>
        # } #
        <span class="pane-field #= data.bsc # #= data.containerClasses # #if (data.clearable) { #clearable-input-container# }#">
            <input data-lpignore="true" class="# if (data.readonly) { # read-only # } #  bind-value pane-field-input #= data.classes || "" ##if (data.clearable) { # clearable-input # }#"  type="text" id="#= data.id #"
                # if (data.placeholder) { # placeholder="#=data.placeholder#" # } #
                # if (data.valueWidth)  { # style="width: #=data.valueWidth #px;" # } #
                # if (data.required) { # required # } # # if (data.pattern) { # pattern="#= data.pattern #" # } #
                # if (data.maxLength) { # max-length="#= data.maxLength #" # } #
                # if (data.min) { # min="#= data.min #" # } # # if (data.max) { # max="#= data.max #" # } #
                # if (data.step) { # step="#= data.step #" # } #
                # if (data.bindValue) { # data-bind="#= data.bindValue #" # } #
                # if (data.disabled) { # disabled="#= data.disabled #" # } #
                # if (data.readonly) { # readonly="#= data.readonly #" # } #
                # if (data.toolTip) { # title="#= data.toolTip #" # } #
                # if (data.name || data.entityType) { # name="#= data.name || data.entityType #" # } #
                # if (data.valueUpdate) { # data-value-update="#= data.valueUpdate #" # } #
                autocomplete="no!"
            />
            # if (data.bindNumberValue) { # <span class="pane-field-number bind-value  #= data.classes || "" # # if (data.disabled) { # disabled # } # "  data-bind="#= data.bindNumberValue #"></span> # } #
            # if (data.bindTextAbove) { # <span class="pane-field-number bind-value  #= data.classes || "" # # if (data.disabled) { # disabled # } # "  data-bind="#= data.bindTextAbove #"></span> # } #
            # if (data.required) { #
                <span class="required">
                </span>
            # } #
            # if (data.iconType) { # 
                <a id="#= data.iconId #" class="js-icon-type #= data.iconType # #= data.iconClasses # # if (data.disabled) { # disabled # } #">
                # if (data.iconType == 'tech' || data.iconType == 'small-tech') { #
                    <i class="fas tech-badge"></i>
                # } #
                </a>
             # } #
            # if (data.useLink && data.linkedTo && data.linkedToBind) { # 
                <label class="linked-wrapper">
                    <input id="#= data.id#_linked" type="checkbox" # if (data.disabled) { # disabled # } # class="linked-input bind-value" data-bind="checked: #= data.linkedToBind #" autocomplete="no!" />
                    <span class="linked-container #= data.linkedClasses || "" # # if (data.disabled) { # disabled # } #">
                        <span class="icon-link k-icon">
                        </span>
                    </span>
                </label>
            # } #
            # if (data.clearable) { #
                <div class="clear-input" title="#=z.ll("ClearField", true)#">
                </div>
            # } #
        </span>
        # if (data.labelAbove || data.hcLabelAbove) { #
            </div>
        # } #
    #}#
`;
